// extracted by mini-css-extract-plugin
export default {"loadingScreen":"AppLoading_loadingScreen__svYdh"};